import React from 'react';

import { i18n } from '@lt/localization';
import WifiFreeIcon from '@lt/components/icons-react/rebrand/WifiFree';
import WifiPaidRubIcon from '@lt/components/icons-react/rebrand/WifiPaidRub';
import WifiFreeInHollIcon from '@lt/components/icons-react/rebrand/WifiFreeInHoll';
import WifiPaidInHollRub from '@lt/components/icons-react/rebrand/WifiPaidInHollRub';
import HotelFeature from '../HotelFeature';

export const WIFI_TYPES = {
  FREE: {
    Icon: <WifiFreeIcon />,
    label: i18n.t('hotelcard.facts.wifi.everywhere'),
  },
  LOBBY_FREE: {
    Icon: <WifiFreeInHollIcon />,
    label: i18n.t('hotelcard.facts.wifi.lobby'),
  },
  PAID: {
    Icon: <WifiPaidRubIcon />,
    label: i18n.t('hotelcard.facts.wifi.paid_label'),
  },
  LOBBY_PAID: {
    Icon: <WifiPaidInHollRub />,
    label: i18n.t('hotelcard.facts.wifi.lobby'),
  },
  LOBBY_UNKNOWN: {
    Icon: <WifiFreeIcon />,
    label: i18n.t('hotelcard.facts.wifi.lobby'),
  },
};

type WifiTypeFeatureProps = {
  value: string | null;
  isMobile: boolean;
};

const WifiTypeFeature = ({ value, isMobile }: WifiTypeFeatureProps) => {
  if (!value) {
    return null;
  }

  const wifiType = WIFI_TYPES[value && value.toUpperCase()];

  if (!wifiType) {
    return null;
  }
  const { Icon, label } = wifiType;
  return <HotelFeature Label={label} Icon={Icon} isMobile={isMobile} />;
};

export default WifiTypeFeature;
